import store from "../store/store";
import { getAIdubbingAuth } from "../request/aiDubbing";
import { getUserInfo } from "../request/aiDubbing";
import aiAxios from "../request/aihttp";

/**
 * AI 配音（Java 后端）登录态桥接：
 * PHP 登录下发的 token 由 PHP 服务端向其配置的 Java 环境换取，未必是当前前端
 * 所连的环境（本地开发 vs 生产），直接使用必然 401。
 * 此函数在每次页面加载时执行一次：优先验证本环境签发的 token，
 * 否则用 PHP 登录存的用户信息向当前环境换取新 token。
 */
let ensured = false;

async function bridgeToken(userInfo) {
  const { data } = await getAIdubbingAuth({
    userId: userInfo.id,
    userName: userInfo.user_name || userInfo.userName || userInfo.no || "phpUser",
  });
  if (data && data.token) {
    localStorage.setItem("Authorization", data.token);
    localStorage.setItem("Authorization_source", "bridge");
    await getUserInfo().catch(() => {});
    // 桥接成功后关闭可能因 401 弹出的登录框
    store.commit("setDialogVisibleLogin", false);
    return true;
  }
  return false;
}

export async function ensureAiToken() {
  if (ensured) return;
  ensured = true;
  try {
    const userInfo = JSON.parse(localStorage.getItem("userInfo") || "null");
    const cached = localStorage.getItem("Authorization");
    // 标记 token 来源：'bridge' 表示本环境通过 authLogin 换来的；
    // PHP 登录直接下发的 token 是其他环境签发的，不能拿去试探
    const bridged = localStorage.getItem("Authorization_source") === "bridge";

    if (cached && bridged) {
      // 本环境 token：静默验证（不触发全局 401 弹窗/清理），失败再重新桥接
      try {
        const resp = await aiAxios.post("/system/user/getUserInfo", {}, { headers: { "X-Silent-Auth": "1" } });
        if (resp.data && resp.data.data && resp.data.data.id) return;
      } catch (e) { /* token 过期，走重新桥接 */ }
      if (userInfo && userInfo.id) {
        await bridgeToken(userInfo);
      }
      return;
    }
    if (userInfo && userInfo.id) {
      // 有 PHP 登录信息但 token 非本环境签发：直接换取本环境 token
      await bridgeToken(userInfo);
      return;
    }
    // 无 PHP 登录信息：不主动请求（各页面自己的 getAiUserInfo 会处理游客态）
  } catch (e) {
    console.log(e);
  }
}
